import {
  CardLinkWithGAClickButton,
  CardMedia,
  MediaCard,
  MediaCardContent,
  Section,
  SectionSubTitle,
  Swiper,
  SwiperSlide,
  Typography,
} from 'common/components';
import React from 'react';
import { createElementKey } from 'utils';
import { CONSTRUCTION_HOUSES_ELEMENT_BLOCK } from 'landings/construction-houses/construction-houses-constants';
import { CONSTRUCTION_HOUSES_ADVICE_DATA } from './construction-houses-advice-section-constants';
import {
  constructionHousesAdviceContent,
  constructionHousesAdviceImage,
  constructionHousesAdviceName,
  constructionHousesAdviceSlide,
  constructionHousesAdviceSwiper,
} from './construction-houses-advice-section-styles';

export const ConstructionHousesAdviceSection: React.FC = () => (
  <Section>
    <SectionSubTitle margin="m">Советы по&nbsp;строительству дома</SectionSubTitle>
    <Swiper slidesPerView="auto" className={constructionHousesAdviceSwiper}>
      {CONSTRUCTION_HOUSES_ADVICE_DATA.map((advice, index) => (
        <SwiperSlide key={createElementKey('advice', index)} className={constructionHousesAdviceSlide}>
          <CardLinkWithGAClickButton
            elementBlock={CONSTRUCTION_HOUSES_ELEMENT_BLOCK}
            elementName={advice.name}
            elementText="Советы по строительству дома"
            title={advice.name}
            href={advice.link}
            rel="noreferrer">
            <MediaCard>
              <CardMedia
                alt={advice.imageAlt}
                className={constructionHousesAdviceImage}
                loading="lazy"
                src={advice.imageSrc}
                title={advice.imageAlt}
                width="377"
                height="262"
              />
              <MediaCardContent className={constructionHousesAdviceContent}>
                <Typography className={constructionHousesAdviceName} variant="h3">
                  {advice.name}
                </Typography>
              </MediaCardContent>
            </MediaCard>
          </CardLinkWithGAClickButton>
        </SwiperSlide>
      ))}
    </Swiper>
  </Section>
);
